import {Injectable} from '@angular/core';
import type {HttpRequest} from '@angular/common/http';
import pageDefaultData from './data/page-default.json';

@Injectable({
    providedIn: 'root',
})
export class MockDataService {
    getMockData(request: HttpRequest<any>) {
        const url: URL = new URL(request.url);
        const endpoint: string = url.pathname;

        switch (endpoint) {
            // case '/api/1.0/service-provider/2':
            //     return serviceProviderData;
            // case '/api/1.0/pages':
            //     return pagesData;
            case '/api/1.0/page/default':
                return pageDefaultData;
            default:
                console.log(
                    '❗️ This endpoint is not being intercepted by the mock service:',
                    endpoint
                );
                return null;
        }
    }

}
